import { Stack, Text, ThemeIcon } from "@mantine/core";

interface Props {
  icon: React.ReactNode;
  message: string;
  action?: React.ReactNode;
}

/** Designed empty state: a muted circular icon, a dimmed message, an optional
 *  action. Replaces bare "… алга байна." text across the billing screens. */
export function EmptyState({ icon, message, action }: Props) {
  return (
    <Stack align="center" gap="sm" py={48}>
      <ThemeIcon variant="light" color="gray" size={56} radius="xl">
        {icon}
      </ThemeIcon>
      <Text c="dimmed" size="sm" ta="center" maw={360}>{message}</Text>
      {action}
    </Stack>
  );
}
